export default "__VITE_ASSET__BrNOCyPD__"